export type WizardWorkingConditions = {
  id?: number
  name: string
  description?: string | null
  maxAnnualHours?: number | null
  minRestHoursBetweenDays?: number | null
  maxDailyHours?: number | null
  maxWeeklyHours?: number | null
  bankHolidaysTreatment?: string | null
  stepWithError?: boolean
}

export const BankHolidaysTreatmentOptions = {
  NON_WORKING: 'non_workable',
  WORKING: 'workable',
}
